import { Formik } from 'formik';
import React from 'react';
import { StylovyzeFormContext } from '../contexts/StylovyzeFormContext';
import { FORM_MODES } from '../../../utils/constants';
export default function StylovyzeFormV2({ mode = FORM_MODES.EDIT, ...props }) {
    return (React.createElement(StylovyzeFormContext.Provider, { value: {
            mode,
            stylovyzeFields: {},
            setStylovyzeFields: () => void 0,
        } },
        React.createElement(Formik, { ...props })));
}
